/** @format */

export const pSidData = () => {
  const isBrowser = typeof window !== 'undefined';
  let dataPsid = '';
  let isPsid = false;
  if (isBrowser) {
    isPsid = window.location.search.includes('pSid');
    if (isPsid) {
      const path = window.location.search.split('pSid=');
      dataPsid = path[1];
    }
  }
  return { isPsid, dataPsid };
};
